import React, { useCallback, useEffect, useState } from "react";
import { GET_ANNOUNCEMENTS } from "../../../api/apiAnuncios";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { PropagateLoader } from "react-spinners";
import moment from "moment/moment";
import NoData from "../../atoms/NoData";
import { useNavigate } from "react-router-dom";
import useModal from "../../../hooks/useModal";
import Modal from "../../molecules/Modal";
import Button from "../../atoms/Button";
import { useSession } from "../../../context/SessionContext";

const AnunciosDashBoard = () => {
    const [anuncios, setAnuncios] = useState();
    const [anuncio, setAnuncio] = useState();
    const [loading, setLoading] = useState(false);
    const  navigate = useNavigate();
    const { open, close, isOpen } = useModal();
    const { user } = useSession();

    const handlePush = () => {
        navigate("/avisos");
    };

    const handleOpen = (anuncio) => {
        setAnuncio(anuncio);
        open();
    };

    const getAnnouncements = useCallback ( async () => {
        try {
            setLoading(true);
            const dataAnnouncements = await GET_ANNOUNCEMENTS();
            const haceUnMes = moment().subtract(1, 'months');
            const anunciosRecientes = dataAnnouncements.filter(anuncio =>
                moment(anuncio.createdAt).isAfter(haceUnMes)
            );

            let anunciosFiltrados = [];

            if (user?.role === "Accountant") {
                anunciosFiltrados = anunciosRecientes.filter(
                    a => a.type === "General" || a.type === "Accountant"
                );
            }
            else if (user?.role === "Lawyer") {
                anunciosFiltrados = anunciosRecientes.filter(
                    a => a.type === "General" || a.type === "Lawyer"
                );
            } else if (user?.role === "Admin" || user?.role === "HumanResources" ) {
                anunciosFiltrados = anunciosRecientes;
            }
            else {
                anunciosFiltrados = anunciosRecientes.filter(a => a.type === "General");
            }

            setAnuncios(anunciosFiltrados);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        if (user) getAnnouncements();
    }, [getAnnouncements, user]);

    return (
        <>
            <div
                className="w-full h-60 flex flex-col items-center justify-center p-4 text-center bg-rs-azul rounded-lg hover:bg-rs-rojo shadow-md shadow-black hover:shadow-lg hover:shadow-rs-rojo hover:scale-101"
            >
                {loading ?
                    <PropagateLoader color="red" />
                    : anuncios?.length > 0 ? (
                        <Swiper
                            slidesPerView={1}
                            spaceBetween={30}
                            loop
                            autoplay={{ delay: 5000 }}
                            modules={[Autoplay]}
                            className="max-w-72 md:max-w-[65vw] h-full"
                        >
                        {anuncios?.map((anuncio, index) => (
                            <SwiperSlide key={index} className="h-auto !flex !justify-center !items-center cursor-pointer" onClick={()=>handleOpen(anuncio)} >
                                <div className="w-full p-4 bg-white shadow-md rounded-md">
                                    <h2 className="text-xl font-bold mb-2 text-rs-azul">{anuncio.title}</h2>
                                    <p className="text-gray-600 mb-2">Da click para ver más</p>
                                </div>
                            </SwiperSlide>
                        ))}
                        </Swiper>
                    ) : (
                        <NoData color={"white"}/>
                    )}
            </div>
            {isOpen && anuncio &&
                <Modal title={anuncio.title} onClose={close}>
                    <div className="w-full flex flex-col justify-center items-center">
                        <p className="text-gray-600 mb-2">{anuncio.description}</p>
                        <p className="text-sm text-gray-400">
                            Publicado el {moment(anuncio.createdAt).format('DD/MM/YY')}
                        </p>
                        <Button text="Ver más avisos" onClick={handlePush} />
                    </div>
                </Modal>
            }
        </>
    );
};

export default AnunciosDashBoard;